import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Navbar';

export default function Footer() {
  return (
    <footer style={{ background: '#0d0d0d', borderTop: '1px solid #1e1e1e', padding: '56px 24px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 40, marginBottom: 48 }}>

          {/* Brand */}
          <div>
            <Logo />
            <p style={{ color: '#555', fontSize: 13, marginTop: 16, lineHeight: 1.8 }}>
              Smart live chat and AI chatbot platform for modern businesses. Available 24/7.
            </p>
            <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a href="mailto:halo@msdiscoveries.com" style={{ color: '#555', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>📧</span> halo@msdiscoveries.com
              </a>
              <a href="tel:+919443724724" style={{ color: '#555', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>📞</span> +91 9443724724
              </a>
            </div>

            {/* Follow Us */}
            <div style={{ marginTop: 24 }}>
              <h4 style={{ color: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Follow Us</h4>
              <div style={{ display: 'flex', gap: 10 }}>
                {[
                  { label: 'WhatsApp', icon: '💬', href: 'https://wa.me/919443724724' },
                  { label: 'Instagram', icon: '📸', href: 'https://instagram.com/msdiscoveries' },
                  { label: 'LinkedIn', icon: '💼', href: 'https://linkedin.com/company/msdiscoveries' },
                  { label: 'Facebook', icon: '👥', href: 'https://facebook.com/msdiscoveries' }
                ].map(s => (
                  <a key={s.label} href={s.href} target="_blank" rel="noreferrer" title={s.label}
                    style={{ width: 34, height: 34, background: '#111', border: '1px solid #1e1e1e', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, transition: 'border-color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = '#00d55b'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = '#1e1e1e'}>
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 style={{ color: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Navigation</h4>
            {[['/', 'Home'], ['/plans', 'Pricing'], ['/about', 'About Us'], ['/contact', 'Contact']].map(([to, label]) => (
              <div key={to} style={{ marginBottom: 10 }}>
                <Link to={to} style={{ color: '#555', fontSize: 13, transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#00d55b'}
                  onMouseLeave={e => e.target.style.color = '#555'}>
                  {label}
                </Link>
              </div>
            ))}
          </div>

          {/* Legal */}
          <div>
            <h4 style={{ color: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Legal</h4>
            {[['/terms', 'Terms & Conditions'], ['/privacy', 'Privacy Policy']].map(([to, label]) => (
              <div key={to} style={{ marginBottom: 10 }}>
                <Link to={to} style={{ color: '#555', fontSize: 13, transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = '#00d55b'}
                  onMouseLeave={e => e.target.style.color = '#555'}>
                  {label}
                </Link>
              </div>
            ))}
            <div style={{ marginTop: 24 }}>
              <h4 style={{ color: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Support Hours</h4>
              <p style={{ color: '#555', fontSize: 12, lineHeight: 1.8 }}>Monday – Saturday<br />10:00 AM – 6:00 PM IST</p>
            </div>
          </div>

          {/* Get Started */}
          <div>
            <h4 style={{ color: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Get Started</h4>
            <p style={{ color: '#555', fontSize: 13, marginBottom: 16, lineHeight: 1.7 }}>
              Start chatting with your website visitors today with MSChat.
            </p>
            <Link to="/register" style={{ display: 'inline-block', padding: '10px 20px', background: '#00d55b', color: '#000', borderRadius: 8, fontSize: 13, fontWeight: 700 }}>
              Create Account →
            </Link>
            <div style={{ marginTop: 12 }}>
              <Link to="/login" style={{ color: '#555', fontSize: 13 }}>Already have an account? <span style={{ color: '#00d55b' }}>Login</span></Link>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid #1e1e1e', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <p style={{ color: '#333', fontSize: 12 }}>© 2025 MS Discoveries. All rights reserved.</p>
          <p style={{ color: '#333', fontSize: 12 }}>Governed by Indian Law — Tamil Nadu Jurisdiction</p>
        </div>
      </div>
    </footer>
  );
}
